import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppShell from "@/components/AppShell";
import LoginPage from "@/pages/LoginPage";
import DashboardPage from "@/pages/DashboardPage";
import DirectoryPage from "@/pages/DirectoryPage";
import EmployeeDetailPage from "@/pages/EmployeeDetailPage";
import TasksPage from "@/pages/TasksPage";
import NotificationsPage from "@/pages/NotificationsPage";
import LeavesPage from "@/pages/LeavesPage";
import ReportsPage from "@/pages/ReportsPage";

const TOAST_OPTIONS = {
  style: {
    fontFamily: "IBM Plex Sans, sans-serif",
    border: "1px solid #e5e5e0",
    background: "#ffffff",
    color: "#1c1c19",
  },
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" toastOptions={TOAST_OPTIONS} />
        <Routes>
          <Route path="/" element={<Navigate to="/app" replace />} />
          <Route path="/login" element={<LoginPage />} />
          <Route
            path="/app"
            element={
              <ProtectedRoute>
                <AppShell />
              </ProtectedRoute>
            }
          >
            <Route index element={<DashboardPage />} />
            <Route path="directory" element={<DirectoryPage />} />
            <Route path="directory/:id" element={<EmployeeDetailPage />} />
            <Route path="tasks" element={<TasksPage />} />
            <Route path="notifications" element={<NotificationsPage />} />
            <Route path="leaves" element={<LeavesPage />} />
            <Route path="reports" element={<ReportsPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/app" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
